'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/resolve-pathname.min.js');
} else {
  module.exports = require('./cjs/resolve-pathname.js');
}



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/resolve-pathname/index.js
// module id = 652
// module chunks = 0